import { SoapUtils } from "../../../utils/SoapUtils";

export interface Document {
    folder?:              string;
    readonly?:            string;
    createdByName?:       string;
    id?:                  string;
    acl?:                 string;
    parent?:              string;
    original?:            string;
    name?:                string;
    nameId?:              string;
    description?:         string;
    descriptionId?:       string;
    type?:                string;
    location?:            string;
    category?:            string;
    validByDate?:         string;
    createdBy?:           string;
    fileHandle?:          string;
    lang?:                string;
    recordId?:            string;
    treeHandle?:          string;
    fileSize?:            string;
    printed?:             string;
    childrenNumber?:      string;
    internalNumber?:      string;
    barcode?:             string;
    internalType?:        string;
    fileName?:            string;
    lock?:                string;
    deleted?:             string;
    creationDate?:        string;
    lastChangeDate?:      string;
    validFrom?:           string;
    validTo?:             string;
    deleteDate?:          string;
    lastNextVersionDate?: string;
    parentName?:          string;
    originalName?:        string;
    categoryName?:        string;
    locationName?:        string;
    typeName?:            string;
    lockedByUser?:        string;
    storageId?:           string;
    storageSubdir?:       string;
    isInStorage?:         string;
    mimeContentType?:     string;
    contextId?:           string;
}

export function toDocumentXml(document: Document):string{
    var xml = '<DOCUMENT>';
    xml += SoapUtils.makeNode(document.folder, 'folder');
    xml += SoapUtils.makeNode(document.readonly, 'readonly');
    xml += SoapUtils.makeNode(document.createdByName, 'createdByName');
    xml += SoapUtils.makeNode(document.id, 'id');
    xml += SoapUtils.makeNode(document.acl, 'acl');
    xml += SoapUtils.makeNode(document.parent, 'parent');
    xml += SoapUtils.makeNode(document.original, 'original');
    xml += SoapUtils.makeNode(document.name, 'name');
    xml += SoapUtils.makeNode(document.nameId, 'nameId');
    xml += SoapUtils.makeNode(document.description, 'description');
    xml += SoapUtils.makeNode(document.descriptionId, 'descriptionId');
    xml += SoapUtils.makeNode(document.type, 'type');
    xml += SoapUtils.makeNode(document.location, 'location');
    xml += SoapUtils.makeNode(document.category, 'category');
    xml += SoapUtils.makeNode(document.validByDate, 'validByDate');
    xml += SoapUtils.makeNode(document.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(document.fileHandle, 'fileHandle');
    xml += SoapUtils.makeNode(document.lang, 'lang');
    xml += SoapUtils.makeNode(document.recordId, 'recordId');
    xml += SoapUtils.makeNode(document.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(document.fileSize, 'fileSize');
    xml += SoapUtils.makeNode(document.printed, 'printed');
    xml += SoapUtils.makeNode(document.childrenNumber, 'childrenNumber');
    xml += SoapUtils.makeNode(document.internalNumber, 'internalNumber');
    xml += SoapUtils.makeNode(document.barcode, 'barcode');
    xml += SoapUtils.makeNode(document.internalType, 'internalType');
    xml += SoapUtils.makeNode(document.fileName, 'fileName');
    xml += SoapUtils.makeNode(document.lock, 'lock');
    xml += SoapUtils.makeNode(document.deleted, 'deleted');
    xml += SoapUtils.makeNode(document.creationDate, 'creationDate');
    xml += SoapUtils.makeNode(document.lastChangeDate, 'lastChangeDate');
    xml += SoapUtils.makeNode(document.validFrom, 'validFrom');
    xml += SoapUtils.makeNode(document.validTo, 'validTo');
    xml += SoapUtils.makeNode(document.deleteDate, 'deleteDate');
    xml += SoapUtils.makeNode(document.lastNextVersionDate, 'lastNextVersionDate');
    xml += SoapUtils.makeNode(document.parentName, 'parentName');
    xml += SoapUtils.makeNode(document.originalName, 'originalName');
    xml += SoapUtils.makeNode(document.categoryName, 'categoryName');
    xml += SoapUtils.makeNode(document.locationName, 'locationName');
    xml += SoapUtils.makeNode(document.typeName, 'typeName');
    xml += SoapUtils.makeNode(document.lockedByUser, 'lockedByUser');
    xml += SoapUtils.makeNode(document.storageId, 'storageId');
    xml += SoapUtils.makeNode(document.storageSubdir, 'storageSubdir');
    xml += SoapUtils.makeNode(document.isInStorage, 'isInStorage');
    xml += SoapUtils.makeNode(document.mimeContentType, 'mimeContentType');
    xml += SoapUtils.makeNode(document.contextId, 'contextId');
    xml += '</DOCUMENT>';

    return xml;
}